import { render, staticRenderFns } from "./CoopAuthInfo.vue?vue&type=template&id=5920ca76&scoped=true&"
import script from "./CoopAuthInfo.vue?vue&type=script&lang=js&"
export * from "./CoopAuthInfo.vue?vue&type=script&lang=js&"
import style0 from "./CoopAuthInfo.vue?vue&type=style&index=0&id=5920ca76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920ca76",
  null
  
)

export default component.exports